import { makeStyles } from '@material-ui/core';

export const useAvatarUploadStyles = makeStyles(theme => ({
  card: {
    maxWidth: 140,
    marginLeft: 5,
    padding: 1,
  },
  cardMedia: {
    height: 160,
  },
  input: {
    display: 'none',
  },
}));
